/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface EmployeeImportApiModel { 
    titleBeforeName: string;
    name: string;
    surname: string;
    titleAfterName: string;
    dateOfBirth: string;
    personalNumber?: string | null;
    email?: string | null;
    phone?: string | null;
    birthNumber?: string | null;
    entryExaminationCompleted: boolean;
    streetName?: string | null;
    cityName?: string | null;
    zipValue?: string | null;
    countryName?: string | null;
    registerNumber?: number | null;
    descriptiveNumber?: string | null;
    fullAddress?: string | null;
    errorMessages?: Array<string> | null;
}

